export function capitalizeFirstLetterArray(sentence) {
  const capitalizeSentence = [];
  if (!sentence) return ""; // evita errores con null/undefined
  const slicedSentence = sentence.split(" ");
  for (const s of slicedSentence) {
    const lower = s.toLowerCase();
    const capitalizeWord = lower.charAt(0).toUpperCase() + lower.slice(1);
    capitalizeSentence.push(capitalizeWord);
  }
  return capitalizeSentence.join(' ')
}
